import { Conversation } from "domains/concierge/types";

export const mapConversationServerIdToConversationId = (
    serverId: number | string,
): Conversation["id"] => {
    return `cm-0-${serverId}`;
};
